import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageCp1004 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cp1004Controller() {
    const vm: IPageCp1004 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            exportation: false,
            supprime: false,
            edition:false
        },
        colonnesFixesGauche: [
            { nom: 'drenumref', largeur: 200 },
            { nom: 'dremnt', largeur: 150, total: true }
        ],
        colonnesVisibles: [
            { nom: 'dredat', largeur: 200 },
            { nom: 'refcodnum', largeur: 200 },
            { nom: 'refnomabr', largeur: 300 },
            { nom: 'docnum', largeur: 200 }
        ]
    };
}
